// extracted by mini-css-extract-plugin
export const headline = "schedule-module--headline--aqxnN";
export const item = "schedule-module--item--1Zxcf";